<app-modal-base
  [title]="dialogTitle"
  (onSubmitEvent)="onSubmit()"
  [loading]="loading"
  [isDisabled]="form.invalid"
>
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <div
      *ngIf="data.showSubscriptionMessage"
      class="alert alert-warning"
      role="alert"
    >
      Vous devez renseigner votre adresse de facturation au préalable pour
      pouvoir vous abonner.
    </div>
    <div class="formContainer d-flex justify-content-center">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="form-group row">
          <app-input
            [label]="'firstName'"
            [formControl]="form_firstName"
          ></app-input>
          <app-input [label]="'name'" [formControl]="form_name"></app-input>
        </div>

        <div class="form-group row mb-3">
          <app-input [label]="'email'" [formControl]="form_email"></app-input>
          <app-input
            [label]="'phoneNumber'"
            [type]="'tel'"
            [formControl]="form_phoneNumber"
          ></app-input>
        </div>

        <app-address-form
          formControlName="address"
          [legendDetails]="addressLegend"
        ></app-address-form>
      </form>
    </div>
  </div>
</ng-template>
